import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Home, RefreshCw, Target } from 'lucide-react';
const targets = [{
  icon: <Brain size={32} className="text-brand-orange" data-id="element-299" />,
  title: '👩 Mamás agotadas de vivir en alerta permanente',
  desc: 'Madres de niños con epilepsia que sienten que la enfermedad controla su vida y no al revés.'
}, {
  icon: <Home size={32} className="text-brand-green" data-id="element-300" />,
  title: '🏠 Vivís en cualquier ciudad de Argentina',
  desc: 'Toda la información está adaptada al sistema de salud argentino, obras sociales, prepagas y recursos disponibles en el país.'
}, {
  icon: <RefreshCw size={32} className="text-brand-gold" data-id="element-301" />,
  title: '🆕 Mamás que quieren pasar de reactivas a preventivas',
  desc: 'Querés dejar de apagar incendios y empezar a entender los patrones de tu hijo antes de que ocurra la próxima crisis.'
}, {
  icon: <Target size={32} className="text-brand-amber" data-id="element-302" />,
  title: '🎯 Buscás resultados concretos',
  desc: 'Vas por menos internaciones, menos pánico, más claridad médica y un hijo que pueda ir al colegio, hacer amigos y vivir sin que todos caminen en puntitas de pie a su alrededor.'
}];
export const WhoIsItFor = () => {
  return <section className="py-10 sm:py-14 md:py-20 bg-brand-green text-white" data-id="element-303">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-304">
        <div className="text-center mb-8 sm:mb-12 md:mb-16" data-id="element-305">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold mb-3 sm:mb-4 text-brand-gold" data-id="element-306">
            ¿PARA QUIÉN ES?
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-cream/90" data-id="element-307">
            Diseñado para vos si querés que tu hijo viva con más calidad y menos
            miedo esta semana
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 md:gap-8" data-id="element-308">
          {targets.map((target, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} whileHover={{
          scale: 1.02,
          transition: {
            duration: 0.2
          }
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.35,
          delay: i * 0.1
        }} className="bg-white/10 backdrop-blur-sm p-5 sm:p-6 md:p-8 rounded-2xl border border-white/20 hover:bg-white/15 transition cursor-default" data-id="element-309">
              <div className="bg-white p-3 rounded-xl inline-block mb-4 sm:mb-6 shadow-sm" data-id="element-310">
                {target.icon}
              </div>
              <h3 className="text-lg sm:text-xl font-bold mb-2 sm:mb-3" data-id="element-311">
                {target.title}
              </h3>
              <p className="text-cream/80 leading-relaxed text-sm sm:text-base" data-id="element-312">
                {target.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="mt-10 sm:mt-14 md:mt-16 text-center" data-id="element-313">
          <a href="#pricing" className="inline-flex items-center gap-2 text-brand-gold hover:text-white font-bold text-base sm:text-lg transition group" data-id="element-314">
            ¿No estás segura si es para vos? Tenés 7 días de garantía total
            <span className="group-hover:translate-x-1 transition-transform" data-id="element-315">
              →
            </span>
          </a>
        </div>
      </div>
    </section>;
};